import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PageState } from 'app/store/models/page.model';

import { setBannerComponent } from 'app/store/actions/page.action';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  constructor(private store: Store<PageState>) {
    this.store.dispatch(setBannerComponent({ banner: 'Contact us' }));
  }

  ngOnInit() {}
}
